import { useEffect } from "react";
export const useClickAndEscape = (ref, isActive, callback) => {
    useEffect(() => {
        const handleInteraction = (event) => {
            if (ref.current &&
                event instanceof MouseEvent &&
                !ref.current.contains(event.target)) {
                callback();
            }
            if (event instanceof KeyboardEvent && event.key === "Escape") {
                callback();
            }
        };
        if (isActive) {
            document.addEventListener("mousedown", handleInteraction);
            document.addEventListener("touchstart", handleInteraction);
            document.addEventListener("keydown", handleInteraction);
        }
        return () => {
            document.removeEventListener("mousedown", handleInteraction);
            document.removeEventListener("touchstart", handleInteraction);
            document.removeEventListener("keydown", handleInteraction);
        };
    }, [isActive, callback, ref]);
};
